import { APP_CONFIG, Environment, AppType } from './app-config';

/**
 * Detecta o ambiente atual baseado na URL
 */
export const getCurrentEnvironment = (): Environment => {
  const hostname = window.location.hostname;
  
  // Em desenvolvimento, o hostname geralmente é localhost
  if (hostname === 'localhost' || hostname === '127.0.0.1') {
    return 'development';
  }
  
  return 'production';
};

/**
 * Gera a URL completa para uma rota específica
 * @param route - A rota (ex: '/nova-venda')
 * @param appType - 'react' ou 'angular'
 */
export const generateRouteUrl = (route: string, appType: AppType = 'angular'): string => {
  const environment = getCurrentEnvironment();
  const config = APP_CONFIG[environment][appType];
  
  // Remove barra inicial da rota se existir para evitar duplicação
  const cleanRoute = route.startsWith('/') ? route.substring(1) : route;
  
  // Monta a URL completa
  if (config.routePrefix) {
    return `${config.baseUrl}${config.routePrefix}/${cleanRoute}`;
  } else {
    return `${config.baseUrl}/${cleanRoute}`;
  }
};

/**
 * Navega para uma rota específica considerando se é React ou Angular
 * @param route - A rota de destino
 * @param isReactRoute - Se é uma rota do React
 */
export const navigateToRoute = (route: string, isReactRoute: boolean = false): void => {
  const appType: AppType = isReactRoute ? 'react' : 'angular';
  const environment = getCurrentEnvironment();
  
  // Em desenvolvimento, se estamos navegando para uma rota React 
  // e já estamos no React (porta 8080), usa roteamento interno
  if (isReactRoute && 
      environment === 'development' && 
      window.location.port === '8080') {
    // Navegar internamente no React (usando React Router)
    window.history.pushState({}, '', '/v2' + route);
    // Dispara evento customizado para o React Router reagir
    window.dispatchEvent(new PopStateEvent('popstate', {}));
  } else {
    // Navegar para outra aplicação ou ambiente
    const url = generateRouteUrl(route, appType);
    window.location.href = url;
  }
};
